export default function ChatHistory() {
  return (
    <div className="p-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold mb-1">Chat History</h1>
        <p className="text-sm text-muted-foreground">
          View all text-based conversations with your agents
        </p>
      </div>
      <div className="flex items-center justify-center h-96 border-2 border-dashed border-border rounded-lg">
        <p className="text-muted-foreground">Coming soon</p>
      </div>
    </div>
  );
}
